import React, {Component} from 'react';
import { newReviseUser, reviseTUser, getDateRangeString, getDateTimeRangeString, isBeforeDate, sendMailById, putToast} from "../../api";
import Modal from 'react-responsive-modal';
import ReactHtmlParser from "react-html-parser";
import moment from 'moment';
import TournamentProfile from "../../pages/pageParts/inputForms/tournamentProfileForm"
import { Link } from 'react-router-dom';

import './tournament.css'

const TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE;
const TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE;
const TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE = process.env.REACT_APP_TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE;

class TournamentBanner extends Component {
    constructor(props) {
        super(props);
        this.register = this.register.bind(this);

        this.state = {
            roundScheduleModalOpen: false,
            open: false,
            user: this.props.user,
            tUser: this.props.tUser,
            tData: this.props.tData
        }

    }

    onOpenRoundScheduleModal = () => {
        this.setState({ roundScheduleModalOpen: true });
    };

    onCloseRoundScheduleModal = () => {
        this.setState({ roundScheduleModalOpen: false });
    };

    rounds = (tData) => {
        return tData.schedule.map(x=> { 
            return {
            roundIndex: x.roundIndex,
            mode: x.mode,
            title: x.title,
            startDate: x.startDate,
            stopDate: x.stopDate
        }  })
    }

    register(registrationMode) {
       this.setState({open: true, judgeClass: registrationMode})
    };

    onCloseTournamentProfileModal = (mode, values) => {
        if (mode === 'tournamentProfile') {
            let user = this.state.user;
            let tUser = this.state.tUser;
            
            // change the user
            // note, we are saving locally here to the user, but using the values object to send to the server
            // this keeps us ok.
            user.club = values.club
            user.experience = values.experience
            user.ageGroup = values.age
            user.gender = values.gender
            user.phone = values.phone
            user.plainPhone = user.phone.replace(/[^0-9]/g, '');

            values.ageGroup = values.age;
            
            newReviseUser({club: values.club, experience: values.experience, ageGroup: values.age, 
                gender: values.gender, phone: values.phone, plainPhone:  values.phone.replace(/[^0-9]/g, '')}, user._id)
            .then(d2 => { 
                // change the tUser
                tUser.isGuest = values.judgeClass === 'guest';
                tUser.isCompetitor = values.judgeClass === 'competitor';
                tUser.isJudge = (values.judgeClass === 'alumni' || values.judgeClass === 'parent' || values.judgeClass === 'community');
                
                const sendMessage = !tUser.isProfileComplete;

                tUser.isProfileComplete = true;
                tUser.status = 'Pending'

                tUser.displayname = user.displayname;
                tUser.firstname = user.firstname;
                tUser.lastname = user.lastname;
                tUser.email = user.email;
                tUser.phone = user.phone;
                tUser.gender = user.gender;
                tUser.experience = user.experience;
                tUser.ageGroup = user.ageGroup;
                tUser.club = user.club;
                tUser.plainPhone = user.plainPhone;

                tUser.judgeClass = values.judgeClass;
                tUser.guestOfEmail = values.guestOfEmail

                reviseTUser(tUser).then(d3 => {
                    if (!d3 || d3.error) {
                        console.log(d3 ? d3.error : "Error - no data");
                        putToast.error(d3 ? d3.error : "Error - no data");
                    } else {
                        putToast.success(d3.message);
                        if (sendMessage) { // send notification the first time they finish profile
                            if (tUser.isJudge) sendMailById(TOURNAMENT_WELCOME_JUDGE_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                            if (tUser.isCompetitor) sendMailById(TOURNAMENT_WELCOME_COMPETITOR_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                            if (tUser.isGuest) sendMailById(TOURNAMENT_WELCOME_GUEST_EMAIL_TEMPLATE, [tUser.userId], {tournament: this.state.tData._id})
                        }
        
                        this.setState({ open: false, user: user, tUser: d3.tUser}); 
                        if (this.props.onUpdate) this.props.onUpdate(d3.tUser);
                    }
                });

            })
        } 
    };
    
    componentDidUpdate(prevProps) {
        if(prevProps.tData !== this.props.tData || prevProps.user !== this.props.user || prevProps.tUser !== this.props.tUser) {
            this.setState({ tData: this.props.tData, tUser: this.props.tUser, user: this.props.user });
        }
    }
    
    render() {     
        const {tData, tUser, user} = this.state;

        const data = {
            club: user.club,
            experience: user.experience,
            gender: user.gender,
            age: user.ageGroup,
            phone: user.phone,
            judgeClass: tUser.judgeClass, // last two fields specific to tUser
            guestOfEmail: tUser.guestOfEmail
        }

        return (
            <section className="blog-detail-page section-b-space" style={{paddingBottom: "2px"}}>
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6" style={{paddingBottom: "8px",  marginBottom: "8px"}}>                                           
                            <div className="card" >
                                <div className="card-header" style={{paddingLeft: "8px", paddingRight: "8px", paddingBottom: "0px", paddingTop: "8px"}}>
                                <h3 >{tData.title}
                                {user.isLoggedIn && tUser.status === 'New' &&
                                <div>
                                    {moment().isBefore(tData.endDate) && <button type="button" className="btn btn-primary" onClick={() => this.register('alumni')} style={{margin: "10px 6px"}}>Judge</button>  }
                                    {moment().isBefore(tData.endRegDate) && <button type="button" className="btn btn-primary" onClick={() => this.register('competitor')} style={{margin: "10px 6px"}}>Compete</button> }

                                </div>
                                }
                                </h3>

                                {!user.isLoggedIn && 
                                <div >
                                    <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>To Sign up - Login or create an account by going <Link style={{color: "white"}} to="/pages/login">HERE</Link>.</p>
                                </div>
                                }
                                </div>   

                                <div className="card-body" style={{paddingTop: "4px", paddingBottom: "4px"}}>
                                    
                                    {tData.imageUrl && 
                                        <img src={tData.imageUrl} className="sizedImg img-fluid blur-up lazyload bg-img" alt=""
                                      
                                        />
                                    }

                                    <div className="dashboard">
                                        <div className="box-account box-info">
                                            <TournamentProfile 
                                                open={this.state.open}
                                                judgeClass={this.state.judgeClass}
                                                tournamentMode
                                                lockedJudgeClass={tUser.isRegistered || (tUser.isJudge && tUser.isAvailableComplete)}
                                                lockedOutCompetitors={!isBeforeDate(new Date(), new Date(tData.endRegDate))}
                                                data={data} 
                                                title="Tournament Profile"
                                                onCloseModal={this.onCloseTournamentProfileModal}
                                                hideDisplayBox
                                            />  
                                        </div>
                                    </div>                                         
                                </div>
                                <div className="card-footer" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                                    &nbsp;
                                </div>
                            </div>

                            <div className="card" style={{marginBottom: "10px"}}>
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                    <h4>Dates</h4>
                                </div>   

                                <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    <strong>Registration: </strong> {getDateRangeString(tData.startRegDate, tData.endRegDate)}<br/>
                                    <strong>Tournament: </strong>{getDateRangeString(tData.startDate, tData.endDate)}<br/>
                                </div>

                                <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                    <button type="button" className="btn btn-primary" onClick={this.onOpenRoundScheduleModal}>Round Schedule</button>
                                </div>
                            </div> 

                        </div>
                        <div className="col-12 col-sm-6 col-md-6" >

                            <div className="card">
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    <h4>Welcome</h4>
                                </div>   

                                <div className="card-body" style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {   ReactHtmlParser(tData.content)}                                
                                </div>
                                <div className="card-footer" style={{paddingTop: "0px", paddingBottom: "8px"}}>
                                &nbsp;

                                </div>
                            </div>    
                                                        
                            
                        </div>
                    </div>   
                    <Modal open={this.state.roundScheduleModalOpen} onClose={this.onCloseRoundScheduleModal} >
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel2">
                                Round Schedule
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                            {this.rounds(tData).map(x=>                            
                                <div className="row" style={{paddingBottom: "2px",  marginBottom: "2px"}}>
                                    <div className="col-12" >                                           
                                        <strong>{x.title}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                                        <div className="pull-right" >                                           
                                            {getDateTimeRangeString(x.startDate, x.stopDate)}                                        
                                        </div>
                                    </div>
                                </div>
                            )}  
                            </div> 
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.onCloseRoundScheduleModal}>Close</button>
                        </div>
                    </Modal>

            </section>
                   
        )
    }
}

export default TournamentBanner;
